import styled from 'styled-components';

const statusColors = {
  pendiente: { bg: 'rgba(170, 140, 0, 0.1)', text: '#8a6d00', border: 'rgba(170, 140, 0, 0.4)' },
  confirmada: { bg: 'rgba(30, 142, 90, 0.1)', text: '#1e8e5a', border: 'rgba(30, 142, 90, 0.4)' },
  cancelada: { bg: 'rgba(192, 57, 43, 0.08)', text: '#c0392b', border: 'rgba(192, 57, 43, 0.4)' }
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.3em 0.9em;
  border-radius: ${({ theme }) => theme.radii.sm};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  background: ${({ $status }) => (statusColors[$status] || statusColors.pendiente).bg};
  color: ${({ $status }) => (statusColors[$status] || statusColors.pendiente).text};
  border: 1px solid ${({ $status }) => (statusColors[$status] || statusColors.pendiente).border};
`;

export default Badge;
